const config = {
  basename: import.meta.env.VITE_BASE_URL || '/aetos-cube',
  defaultPath: '/',
  fontFamily: `'Roboto', sans-serif`,
  borderRadius: 0,
  stacBackendurl: import.meta.env.VITE_STAC_BACKEND_URL || '/api/stac/v1',
  mainBackendUrl: import.meta.env.VITE_MAIN_BACKEND_URL || '/api/v1',
  regionBoundaryUrl: import.meta.env.VITE_REGION_BOUNDARY_URL || 'https://api-aws.eofactory.ai/api/territories',
  adminRole: 'DATACUBE_ADMIN',
  tileServerUrl: import.meta.env.VITE_TILE_SERVER_URL.split(',') || [],
  backendUrl: import.meta.env.VITE_BACKEND_URL || '',
  authUrl: import.meta.env.VITE_AUTH_URL || '',
  companionUrl: import.meta.env.VITE_COMPANION_URL || '/companion',
  geocodeUrl: import.meta.env.VITE_GEOCODE_URL || '/api/services/geocode',
  mapStyleUrl: import.meta.env.VITE_MAP_STYLE_URL || 'https://tiles.aetosky.com/data/world.json',
  assetUrl: import.meta.env.VITE_ASSET_URL || 'api/services/assets/'
}

export default config
